// Utils
import cn from '../../../utils/cn';

// Styles
import styles from './Iframe.module.css';

/**
 * Iframe component - Embeds an external page in a sandboxed frame
 * @param {object} props
 * @param {string} props.src - URL of the embedded page
 * @param {string} props.title - Accessible title of the frame
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element}
 */
function Iframe({ src, title, className }) {
  return (
    <iframe
      src={src}
      title={title}
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      referrerPolicy="no-referrer-when-downgrade"
      loading="lazy"
      className={cn([styles.iframe, ...(className ? [className] : [])])}
    />
  );
}

export default Iframe;
